import { Link } from 'react-router-dom';
import { Gift, Heart } from 'lucide-react';

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  const footerLinks = {
    navigation: [
      { name: 'Startseite', path: '/' },
      { name: 'Geschenke', path: '/geschenke' },
      { name: 'Ramadan 2026', path: '/ramadan' },
      { name: 'Eid ul Fitr', path: '/eid-ul-fitr' },
      { name: 'Eid ul Adha', path: '/eid-ul-adha' },
      { name: 'Ratgeber & FAQ', path: '/ratgeber' },
      { name: 'Über uns', path: '/ueber-uns' },
    ],
    legal: [
      { name: 'Impressum', path: '/impressum' },
      { name: 'Datenschutz', path: '/datenschutz' },
    ],
  };

  return (
    <footer className="bg-[#2C332E] text-white">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-16 md:py-20">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 md:gap-8">
          {/* Brand Section */}
          <div className="md:col-span-5">
            <Link to="/" className="flex items-center gap-2 mb-6" data-testid="footer-logo">
              <div className="w-10 h-10 rounded-full bg-[#4A5D4F] flex items-center justify-center">
                <Gift className="w-5 h-5 text-white" />
              </div>
              <span className="font-serif text-2xl font-medium">
                EidGeschenke
              </span>
            </Link>
            <p className="text-[#9CA3AF] leading-relaxed mb-6 max-w-sm">
              Sorgfältig ausgewählte Geschenkideen für Eid ul Fitr und Eid ul Adha. 
              Sorgfältig ausgewählt für Familien, Kinder und Freunde.
            </p>
            <p className="text-sm text-[#6B7280] flex items-center gap-1">
              Mit <Heart className="w-4 h-4 text-[#D4C5A9]" /> gemacht in Deutschland
            </p>
          </div>

          {/* Navigation Links */}
          <div className="md:col-span-3">
            <h4 className="font-serif text-lg font-medium mb-6">Navigation</h4>
            <ul className="space-y-3">
              {footerLinks.navigation.map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    data-testid={`footer-nav-${link.path.replace('/', '') || 'home'}`}
                    className="footer-link text-[#9CA3AF] hover:text-white transition-colors duration-200"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Legal Links */}
          <div className="md:col-span-2">
            <h4 className="font-serif text-lg font-medium mb-6">Rechtliches</h4>
            <ul className="space-y-3">
              {footerLinks.legal.map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    data-testid={`footer-legal-${link.path.replace('/', '')}`}
                    className="footer-link text-[#9CA3AF] hover:text-white transition-colors duration-200"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Affiliate Notice */}
          <div className="md:col-span-2">
            <h4 className="font-serif text-lg font-medium mb-6">Hinweis</h4>
            <p className="text-sm text-[#6B7280] leading-relaxed">
              Einige Links auf dieser Seite sind Partnerlinks. Wenn du über diese Links einkaufst, 
              erhalten wir eine kleine Provision. Für dich entstehen keine zusätzlichen Kosten.
            </p>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-16 pt-8 border-t border-[#3D4440]">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-sm text-[#6B7280]">
              © {currentYear} EidGeschenke.de. Alle Rechte vorbehalten.
            </p>
            <p className="text-xs text-[#6B7280]">
              Eid Mubarak – Möge euer Fest gesegnet sein
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};
